import { bool } from 'prop-types'

const checked = bool

export { checked }
